export enum EDeductionCategory {
  Discount = "Discount",
  Referral = "Referral",
  Promotion = "Promotion",
  Sale = "Sale",
  Grant = "Grant",
  CarbonCredit = "CarbonCredit"
}
